import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class InspectionRealEndDateOptionsVM extends CommonOptionVM {
  required?: true
  not_visible?: true

  constructor(data: Partial<InspectionRealEndDateOptionsVM> = {}) {
    super(data)
    this.required = true
    this.not_visible = true
  }

  validateData() {
    const errors: any[] = []
    if (this.required !== true) {
      errors.push({ key: 'required', error_message: 'required must be true' })
    }
    if (this.not_visible !== true) {
      errors.push({ key: 'not_visible', error_message: 'not_visible must be true' })
    }
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default InspectionRealEndDateOptionsVM